import React, { useEffect, useState } from "react";
import Header from "../../../../../Componets/Header";
import Table from "../../../../../Componets/Table";
import Status from "../../../../../Componets/Status";
import ActionButton from "../../../../../Componets/Buttons/action";
import Loadercomponent from "../../../../../Componets/Loader";
import toast from "react-hot-toast";
import tables from "../../../../../Data/Tables/Accounting/ManualEntry/tables";
import headers from "../../../../../Data/Tables/Accounting/ManualEntry/header";
import { get_all_manual_journals, get_manual_journal } from "../../../../../Controllers/Accounting/Services/manualJournalsService";
import DocumentCell from "../../../../../Componets/DocumentsCell/DocumentCell"; 

const ManualJournalTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch (e) {
      return "-";
    }
  };

  const formatTime = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    } catch (e) {
      return "-";
    }
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);


      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        status: tabledata?.status,
        page: tabledata?.currentPage,
        limit: 10,
      };

      const journals = await get_all_manual_journals(data);
      const particular = await get_manual_journal("68de2282f05d08100c105274");


      if (journals?.success) {
        let data = [];

        journals?.data?.forEach((journal, index) => {
          journal.entries?.forEach((entry, entryIndex) => {
            data.push({
              path: `/app/manual-journals/view/${journal?._id}`,
              "Journal Date": formatDate(journal?.date || journal?.createdAt),
              Time: formatTime(journal?.updatedAt),
              Reference: journal?.referenceNumber || "-",
              Description: journal?.description || "-",
              "Account Code": entry?.account?.code || "-",
              "Account Name": entry?.account?.name || "-",
              Debit:
                entry.type === "debit" ? (
                  <span className="text-green-600 font-semibold">
                    {parseFloat(entry.amount).toFixed(3)}
                  </span>
                ) : (
                  "-"
                ),
              Credit:
                entry.type === "credit" ? (
                  <span className="text-red-600 font-semibold">
                    {parseFloat(entry.amount).toFixed(3)}
                  </span>
                ) : (
                  "-"
                ),
              Attachments: <DocumentCell documents={journal?.documents} />,
              Status: <Status status={journal?.status === "posted" ? 1 : 0} />,
              Action: (
                <ActionButton
                  edit={`/app/manual-journals/edit/${journal?._id}`}
                  view={`/app/manual-journals/view/${journal?._id}`}
                  id={journal?._id}
                  api="delete-manual-journal"
                  actiondata={actiondata}
                  headers={header}
                />
              ),
            });
          });
        });

        setPagination({
          currentPage: journals?.meta.currentPage || 1,
          totalCount: journals?.meta.totalCount || journals?.data?.length || 0,
          totalPages: journals?.meta.totalPages || Math.ceil((journals?.totalCount || journals?.data?.length || 0) / 10),
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(journals?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  const headerReset = () => {
    let componentData = [];

    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ManualJournalTable;